export default class CardClickArea {

    constructor(el) {

        if(!el) {
            return;
        }

        let down, up, link = el.querySelector('a');
        el.onmousedown = () => down = +new Date();
        el.onmouseup = () => {
            up = +new Date();
            if ((up - down) < 200) {
                link.click();
            }
        }

        el.style.cursor = 'pointer';

    }
}
